import 'Src/less/automotive/service-repair-landing-page.less';
import Vue from 'vue';
import { BlogCategories, BlogTagGroups } from 'Src/js/services/BlogService';
import { initializeAsyncBlogCarousel } from 'Src/js/utilities/blog';
import { initializeChangeStoreButton } from '../shared/utils/store';
import { lazyLoadImages } from 'JS/global/images';

initializeAsyncBlogCarousel('#srlpBlogCarousel', {
	heading: 'Auto Care Tips & Advice',
	viewAllLink: 'https://www.farmandfleet.com/blog/tag/maintenance-repair/',
	query: {
		categories: [BlogCategories.Automotive],
		perPage: 12,
		tags: BlogTagGroups.ServiceRepair, 
	},

});

initializeChangeStoreButton('.alp-store__change', 'auto');

lazyLoadImages(document.querySelector('#srlp') as HTMLElement);